export default __webpack_public_path__ + "static/media/QuitGame_btn.6ac54476.png";